import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsEnum, IsNotEmpty } from 'class-validator';
import { PromotionExposeGroup, PromotionGroupLevelEnum } from '../interface';
export class ReadPromotionMerchantGroupDto {
}
__decorate([
    ApiProperty({ enum: PromotionGroupLevelEnum, description: 'Promotion availability level', example: PromotionGroupLevelEnum.MERCHANT_STORES }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsEnum(PromotionGroupLevelEnum, { always: true }),
    __metadata("design:type", String)
], ReadPromotionMerchantGroupDto.prototype, "level", void 0);
__decorate([
    ApiProperty({
        type: () => String,
        isArray: true,
        description: 'promotion is available only to listed stores of the merchant ',
        example: ['WESTVILLE_WALLSTREET'],
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true, each: true }),
    IsArray({ always: true }),
    __metadata("design:type", Array)
], ReadPromotionMerchantGroupDto.prototype, "whitelist", void 0);
//# sourceMappingURL=ReadPromotionMerchantGroupDto.js.map